import React from "react";
import { cn } from "@/lib/utils";

interface Props {
  value: string;
  onChange: (v: string) => void;
  readOnly?: boolean;
  className?: string;
  style?: React.CSSProperties;
}
const HtmlEditorArea: React.FC<Props> = ({
  value,
  onChange,
  readOnly = false,
  className,
  style
}) => {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      readOnly={readOnly}
      dir="ltr"
      className={cn(
        "w-full resize-y rounded border bg-white font-mono text-sm p-4",
        className
      )}
      style={{
        width: "100%",
        minHeight: "calc(100vh - 8rem)",
        maxHeight: "calc(100vh - 6rem)",
        boxSizing: "border-box",
        fontFamily:
          "ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', monospace",
        fontSize: 13,
        whiteSpace: "pre-wrap",
        overflow: "auto",
        borderRadius: 6,
        border: "1px solid rgba(145,158,171,0.24)",
        background: "#fff",
        ...style
      }}
    />
  );
};

export default HtmlEditorArea;
